
define('text!video-player-modal/video-player-modal.html',[],function () { return '<div id="video-container">\n    <div>\n        <iframe\n                frameborder="0"\n                allowfullscreen="allowfullscreen"\n                src="https://www.youtube.com/embed/GGQITt6QcjY?rel=0">\n        </iframe>\n    </div>\n</div>';});

